module.exports = __webpack_public_path__ + "static/media/sf-test-14.a6ced89f.mp3";